(() => {
  const track = document.querySelector('#brands-track');
  if (!track) return;
  const controls = document.querySelector('.brands-controls');
  const previous = document.querySelector('[data-brands-prev]');
  const next = document.querySelector('[data-brands-next]');
  const items = [...track.querySelectorAll('.brands-list > li')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lastPosition = () => Math.max(0, track.scrollWidth - track.clientWidth);
  const updateControls = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= lastPosition() - 2;
  };
  const scrollTo = (left) => {
    track.scrollTo({ left: Math.max(0, Math.min(left, lastPosition())), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  };
  const step = (direction) => {
    const itemWidth = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    const visibleItems = Math.max(1, Math.floor(track.clientWidth / itemWidth));
    scrollTo(track.scrollLeft + direction * itemWidth * visibleItems);
  };
  previous.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', updateControls, { passive: true });
  track.addEventListener('keydown', (event) => {
    if (event.target !== track) return;
    if (event.key === 'ArrowLeft' || event.key === 'PageUp') step(-1);
    else if (event.key === 'ArrowRight' || event.key === 'PageDown') step(1);
    else if (event.key === 'Home') scrollTo(0);
    else if (event.key === 'End') scrollTo(lastPosition());
    else return;
    event.preventDefault();
  });
  if ('ResizeObserver' in window) new ResizeObserver(updateControls).observe(track);
  else window.addEventListener('resize', updateControls, { passive: true });
  controls.hidden = false;
  updateControls();
})();
